import React, { useEffect } from 'react'
import { AllRoutes } from '../../Pages/AllRoutes/AllRoutes'
import NavBar from '../NavBar/NavBar'
import "./Home.css"
import AllProducts from '../../Pages/AllProducts/AllProducts'


const Home = () => {


 


  return (
    <div className='home-container'>

      
      
      <AllProducts />
    </div>
  )
}

export default Home
